import AkButton from '@atlaskit/button';
import styled from '@emotion/styled';

export const LargeAkButton = styled(AkButton)`
  height: 40px !important;
`;
